import { styled } from "@mui/system";

export const StyledHeaderTitle = styled("div")(({ theme, withoutMarginBottom }) => ({
  backgroundColor: "#fff",
  marginBottom: withoutMarginBottom ? 0 : 115,
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  "& span": {
    width: "100%",
    fontSize: "14px",
    color: "#86868b",
    "& span": {
      fontWeight: "600"
    }
  },
  "&.hideHeaderTile": {
    display: "none"
  },
  [theme.breakpoints.up("sm")]: {
    marginTop: 35
  },
  "& .headerTitleIn": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%"
  },
  "& .logout": {
    float: "right",
    marginTop: "-20px",
    cursor: "pointer"
  }
}));
